import React, { useState } from "react";
import { Row, Col, Card, Menu, Dropdown, Button, Checkbox } from "antd";
import { IoIosAddCircleOutline } from "react-icons/io";
import { BsThreeDotsVertical, BiCheckDouble } from "react-icons/all";
import Chip from "../../assets/images/chip.png";
import straightVisaCard from "../../assets/images/straight_cards_32.png";
import "./index.css";
import info from "../info";
import { useDispatch } from "react-redux";
import { UserAction } from "../../store/actions";
import CustomModal from "../modals/customModal";
import Delete_order from "../../assets/images/delete_order.png";

export default function CreditCard({
  onChangeCard,
  cardStyle,
  data,
  fromOrder,
  tickIcon,
  dotsIcon,
  paidText,
  shipVisaStyling,
  checkBoxBtn,
  cardId,
}) {
  const [isOpenModal, setOpenModal] = useState(false);
  const dispatch = useDispatch();
  const menu = (
    <Menu style={{ width: 0, padding: 0 }} className="menu-fit">
      {!data?.default_source && (
        <Menu.Item
          key="0"
          onClick={() => dispatch(UserAction.setCardDefaultReq(data.id))}
          style={{ marginLeft: "-5px" }}
        >
          <span className="st-primary">Set as default</span>
        </Menu.Item>
      )}

      <Menu.Item
        key="0"
        onClick={
          data?.default_source
            ? () => {
              info(
                "error",
                "Cannot delete default card! Make any other card your default and then delete this card"
              );
            }
            : () => setOpenModal(true)
        }
        style={{ marginLeft: "-5px" }}
      >
        <span className="st-primary">Delete</span>
      </Menu.Item>
    </Menu>
  );
  return (
    <Row justify={fromOrder ? "space-between" : "center"}>
      <Col xs={24} sm={24} md={24} lg={24} xl={24} className="payment-card">
        <Card className="ant-card-body" style={cardStyle}>
          <Row justify="start">
            <Col>
              {tickIcon && (
                <BiCheckDouble
                  color="lightblue"
                  size={25}
                  style={{
                    visibility: !data?.default_source ? "hidden" : "visible",
                  }}
                />
              )}
            </Col>
          </Row>
          <Row justify={"space-between"}>
            {paidText && <Col style={{ margin: "8px" }}>Paid Via</Col>}

            <Col
              xs={5}
              sm={2}
              md={6}
              lg={6}
              xl={6}
              style={{
                margin: shipVisaStyling && "8px -35px 0px 10px",
                height: "28px",
                backgroundImage: !shipVisaStyling && `url(${Chip}) `,
                width: "28px",
                maxHeight: "28px",
                display: "flex",
                backgroundRepeat: "no-repeat",
                justifyContent: "end",
              }}
            >
              {shipVisaStyling && <img src={Chip} />}
            </Col>
            <Col
              xs={9}
              sm={3}
              md={8}
              lg={8}
              xl={6}
              style={{
                margin: shipVisaStyling ? "8px -7px 0px 10px" : null,
                height: data?.source?.object === "card" ? "30px" : "32.5px",
                backgroundImage: `url(${straightVisaCard}) `,
                display: "inline-block",
                position: "relative",
                borderRadius: data?.source?.object === "card" ? "0px" : "5px",
                backgroundPosition:
                  data?.source?.brand === "MasterCard"
                    ? "0px -158px"
                    : data?.source?.brand === "American Express"
                      ? "0 -240px"
                      : data?.source?.brand === "Discover"
                        ? "0 -400px"
                        : data?.source?.brand === "Diners Club"
                          ? "0 -480px"
                          : data?.source?.brand === "JCB"
                            ? "0 -320px"
                            : data?.source?.brand === "UnionPay"
                              ? "0 0px"
                              : data?.source?.object === "card"
                                ? "-4px -78px"
                                : "-2px 0.5px",


                width: "51px",
                backgroundRepeat: 'no-repeat'
              }}
            ></Col>
            <Col
              xs={8}
              sm={4}
              md={10}
              lg={10}
              xl={10}
              style={{
                display: "flex",
                justifyContent: "end",
              }}
            >
              {checkBoxBtn && (
                <Checkbox
                  className="custom-checkbox"
                  onChange={() => onChangeCard(data)}
                  checked={cardId === data.id}
                // value={item.price}
                // onChange={(e) => {}}
                />
              )}
            </Col>
            <Col xs={8} sm={4} md={10} lg={10} xl={12}>
              {dotsIcon && (
                <Dropdown
                  overlay={menu}
                  trigger={["click"]}
                  style={{ width: "40%" }}
                >
                  <BsThreeDotsVertical className="pointer-cursor" />
                </Dropdown>
              )}
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <h5
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  fontSize: "18px",
                  margin: "17px 0",
                }}
              >
                {`**** **** **** ${data?.source?.last4 || 4242}`}
              </h5>
            </Col>
          </Row>
          <Row justify="start">
            <Col xl={data?.source?.object === "card" ? 16 : 24}
              span={12}
            >
              <span
                className="rmx-card-countryName"
                style={{ fontSize: "12px", fontWeight: "600" }}
              >
                {" "}
                {data?.source?.country || "US"}
              </span>
              <span
                className="rmx-card-country"
                style={{ fontSize: "9px", fontWeight: "600" }}
              >
                COUNTRY
              </span>
            </Col>
            <Col
              xl={data?.source?.object === "card" ? 8 : 24}
              span={12}
              className="text-right"
            >
              <span
                style={{ fontSize: "12px", fontWeight: "600" }}
                className={
                  data?.source?.object === "card"
                    ? "rmx-card-expiryDate  text-left"
                    : "rmx-bank-expiryDate  text-left"
                }
              >
                {data?.source?.object === "card"
                  ? `${data?.source?.exp_month || 12}/${data?.source?.exp_year || 2023
                  }`
                  : data?.source?.bank_name}
              </span>
              <span
                style={{ fontSize: "9px", fontWeight: "600" }}
                className={
                  data?.source?.object === "card"
                    ? "rmx-card-expiry text-left"
                    : "rmx-bank-expiry text-left"
                }
              >
                {data?.source?.object === "card" ? "EXP" : "BANK NAME"}
              </span>
            </Col>
          </Row>
        </Card>
      </Col>
      <CustomModal
        visible={isOpenModal}
        onCancelModal={() => setOpenModal(false)}
        footer={[
          <Row justify="center" style={{ margin: "20px" }}>
            <Col
              className="d-flex justify-content-center"
              style={{ width: "100%" }}
            >
              <Button
                style={{
                  backgroundColor: "#ff9800",
                  color: "#fff",
                  width: "30%",
                  border: "none",
                }}
                onClick={() =>
                  dispatch(
                    UserAction.deleteCardReq(data.id, () => setOpenModal(false))
                  )
                }
              >
                YES
              </Button>
              <Button
                style={{
                  backgroundColor: "#26a69a ",
                  color: "#fff",
                  width: "30%",
                  border: "none",
                }}
                onClick={() => setOpenModal(false)}
              >
                NO
              </Button>
            </Col>
          </Row>,
        ]}
      >
        <Row justify="center">
          <Col className="d-flex justify-content-center" span={24}>
            <img src={Delete_order} />
          </Col>
          <Col span={24} style={{ textAlign: "center" }}>
            <span>{"Are you sure you want to delete this card?"}</span>
          </Col>
        </Row>
      </CustomModal>
    </Row>
  );
}
